module.exports = __webpack_public_path__ + "media/src/img/payment/mir_logo-f5030fc9c39833caaba7ee513a93367f.png";